var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.34 250.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#921b1e;}.cls-2{fill:#dc3027;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6623",
    "data-name": "Group 6623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    className: "cls-1",
    d: "M12,250.25A12,12,0,0,1,0,238.31V32.67A32.82,32.82,0,0,1,32.64,0H230.71V1.3a32.84,32.84,0,0,1,23.63,31.34V174.43a32.83,32.83,0,0,1-32.64,32.66H60L20.37,246.75A11.88,11.88,0,0,1,12,250.25ZM32.66,18.08A14.67,14.67,0,0,0,18.08,32.69V223.48L52.55,189H221.67a14.68,14.68,0,0,0,14.59-14.61V32.67a14.68,14.68,0,0,0-14.61-14.59h-189Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6619",
    "data-name": "Group 6619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    "data-name": "Path 7341",
    className: "cls-2",
    d: "M142.25,122.55a9.79,9.79,0,1,1,9.79,9.78h0A9.78,9.78,0,0,1,142.25,122.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6622",
    "data-name": "Group 6622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6620",
    "data-name": "Group 6620"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    "data-name": "Path 7342",
    className: "cls-2",
    d: "M78.05,131.61c-6.08,0-11-4.05-11-9.06s4.92-9.06,11-9.07h39.63c6.07,0,11,4.07,11,9.07s-4.93,9.06-11,9.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6621",
    "data-name": "Group 6621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    className: "cls-2",
    d: "M76.09,95.36a9.06,9.06,0,0,1,0-18.12H181.21a9.06,9.06,0,0,1,0,18.12Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img_3.32be58d97f03536345533b53c4a1929f.svg";
export { ForwardRef as ReactComponent };